import { Box } from '@radix-ui/themes';
import { RefObject } from 'react';
import { ParallaxLayer } from './ParallaxLayer';

interface ParallaxImageProps {
    imageUrl?: string;
    scrollRef: RefObject<HTMLElement | null>;
    speed?: number;
    gradientColor?: string;
    opacity?: number;
}

export const ParallaxImage = ({
    imageUrl,
    scrollRef,
    speed = 0.25,
    // gradientColor = 'var(--gray-1)',
    opacity = 1,
}: ParallaxImageProps) => {
    const fallbackImageUrl = `/images/background/background_2.jpg`;
    const finalImageUrl = imageUrl || fallbackImageUrl;

    // const radialFadeGradient = `radial-gradient(ellipse at bottom left, ${gradientColor}, transparent 33%)`;

    const combinedBackground = `  url(${finalImageUrl})`;

    const maskColor = 'rgba(0,0,0)';

    const radialMask = `radial-gradient(ellipse at top right, 
    ${maskColor} 25%, 
    ${maskColor.replace(')', ', 0.85)')} 35%, 
    ${maskColor.replace(')', ', 0.6)')} 45%, 
    ${maskColor.replace(')', ', 0.35)')} 55%, 
    ${maskColor.replace(')', ', 0.15)')} 62%,     
    ${maskColor.replace(')', ', 0.05)')} 67%, 
    transparent 70%)`;

    return (
        <ParallaxLayer scrollContainerRef={scrollRef} speed={speed} zIndex={0}>
            <Box
                position='absolute'
                top='0'
                right='0'
                width='75%'
                style={{
                    aspectRatio: '16 / 9',
                    opacity: opacity,
                    WebkitMaskImage: radialMask,
                    maskImage: radialMask,
                }}
            >
                <Box
                    width='100%'
                    height='100%'
                    style={{
                        backgroundImage: combinedBackground,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center center',
                        backgroundRepeat: 'no-repeat',
                    }}
                />
            </Box>
        </ParallaxLayer>
    );
};
